import {range} from '@aboutyou/utils';
import {styled} from '@linaria/react';
import type {JSX} from 'react';
import React, {Fragment} from 'react';
import {mobileOnlyLinaria} from '../../../constants/customMedia';
import {SkeletonBlock} from './SkeletonBlock';

interface PlaceholdersProps {
  amount?: number;
  ctaVisible?: boolean;
  TileWrapper?: React.FC<React.PropsWithChildren>;
  disableSkeletonAnimation?: boolean;
  Comp?: keyof JSX.IntrinsicElements;
}

export const PlaceholderTiles: React.FC<
  React.PropsWithChildren<PlaceholdersProps>
> = ({
  amount,
  ctaVisible,
  TileWrapper = Fragment,
  disableSkeletonAnimation,
}) => {
  return (
    <>
      {range(0, amount ?? 6).map(idx => (
        <TileWrapper key={idx}>
          <PlaceholderTile
            ctaVisible={ctaVisible}
            disableSkeletonAnimation={disableSkeletonAnimation}
          />
        </TileWrapper>
      ))}
    </>
  );
};

const PlaceholderTile = (props: {
  ctaVisible?: boolean;
  disableSkeletonAnimation?: boolean;
}) => {
  return (
    <Placeholder>
      <ImageContainerPlaceHolder
        $height="0px"
        disableSpaceBelow
        disableAnimation={props.disableSkeletonAnimation}
      />
      <ProductInfoPlaceholder $ctaVisible={props.ctaVisible}>
        <Brand>
          <SkeletonBlock
            $width="70%"
            disableAnimation={props.disableSkeletonAnimation}
          />
        </Brand>
        <SkeletonBlock
          $width="40%"
          style={{
            borderRadius: 4,
          }}
          disableAnimation={props.disableSkeletonAnimation}
        />
        {props.ctaVisible && (
          <SkeletonButton>
            <SkeletonBlock
              $height="50px"
              $width="100%"
              disableSpaceBelow
              disableAnimation={props.disableSkeletonAnimation}
            />
          </SkeletonButton>
        )}
      </ProductInfoPlaceholder>
    </Placeholder>
  );
};

const SkeletonButton = styled.div`
  border-radius: 4px;
  margin-top: 80px;
`;

const Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

const Brand = styled.div`
  border-radius: 4px;
  width: 100%;
  height: 18px;
  margin-bottom: 5px;

  ${mobileOnlyLinaria(`
    display: flex;
    justify-content: center;
  `)}
`;

const ProductInfoPlaceholder = styled.div<{$ctaVisible?: boolean}>`
  align-items: flex-start;
  height: ${({$ctaVisible}) => ($ctaVisible ? 'auto' : '140px')};
  padding: 15px 15px 25px;

  ${mobileOnlyLinaria(`
    padding: 12px 12px 19px;
    height: 87px;
    align-items: center;
    display: flex;
    flex-direction: column;
  `)}
`;

const ImageContainerPlaceHolder = styled(SkeletonBlock)`
  padding-top: 133.333%;
`;
